import { useMemo } from 'react'
import { useTenantSettings } from 'react-common'

type KnowledgeModelId = string
type WidgetSetting = {
  objectiveId: string
  initialExpanded: boolean
}
type TutorTenantSetting = {
  enabled: boolean
  defaultKnowledgeModelId: KnowledgeModelId
  widgetSettings?: WidgetSetting[]
}

export const useKnowledgeModelSettings = (objectiveId?: string) => {
  const tenantSettings = useTenantSettings<TutorTenantSetting>('learner.tutor', true)

  const initialExpanded = useMemo(() => {
    const objectiveWidgetSetting = tenantSettings?.widgetSettings?.find(
      (setting) => setting.objectiveId === objectiveId,
    )
    return objectiveWidgetSetting?.initialExpanded ?? false
  }, [objectiveId, tenantSettings?.widgetSettings])

  return {
    defaultKnowledgeModelId: tenantSettings?.defaultKnowledgeModelId,
    enabled: tenantSettings?.enabled,
    initialExpanded,
  }
}
